var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BjDialogList", {
    ref: "dialogStoresList",
    attrs: { config: _vm.shopOnlineDefault, "row-keys": "code" },
    on: { confirm: _vm.dialogListConfirm },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }